export default {
    post: function (url, data) {
        return new Promise(function (resolve, reject) {

            //Email required
            if (data.email == null || data.email === '') {
                reject({
                    status: 400,
                    body:
                        [
                            {
                                property: 'Email',
                                message: 'MESSAGE__ACCOUNT__EMAIL_REQUIRED'
                            }
                        ]
                });
                return;
            } else {
                //Email is not valid
                const re = /\S+@\S+\.\S+/;
                if (!re.test(data.email)) {
                    reject({
                        status: 400,
                        body:
                        [
                            {
                                property: 'Email',
                                message: 'MESSAGE__ACCOUNT__EMAIL_NOT_VALID'
                            }
                        ]
                    });
                    return;
                }
            }

            //Ok
            resolve({
                body: null
            });
        });
    }
}



// WEBPACK FOOTER //
// ./test/data/account/sendPasswordResetLink.js